import i18n from "i18next";
import { Fragment } from "react";
import { inject, observer } from "mobx-react";

import { PlayIcon } from "../components/icons/PlayIcon.component";
import { StopIcon } from "../components/icons/StopIcon.component";
import { DynamicHeaderItem } from "./DynamicHeaderItem.component";
import styles from "./HeaderPlayback.module.scss";
import type { Store } from "@inferno/renderer-shared-core";

export interface HeaderPlaybackProps {
  store?: Store;
}

export const HeaderPlayback = inject("store")(
  observer(({ store }: HeaderPlaybackProps) => {
    if (!store) {
      return null;
    }

    const { playback, inProgress, togglePlayback } = store.player;

    return (
      <DynamicHeaderItem
        store={store}
        className={styles.componentPlayback}
        iconOnlyClassName={styles.iconOnly}
        buttonClassName={styles["toggle-btn"]} // Fixed class name reference
        ariaLabel="Play Stream Now"
        onClick={() => togglePlayback(store, { sectionName: "header" })}
        content={
          playback ? (
            <Fragment>
              <StopIcon />
              {i18n.t("listen_stop")}
            </Fragment>
          ) : (
            <Fragment>
              <PlayIcon />
              {i18n.t("listen_play")}
            </Fragment>
          )
        }
        mobileContent={
          playback ? (
            <Fragment>
              <StopIcon />
              {i18n.t("listen_stop_mob")}
            </Fragment>
          ) : (
            <Fragment>
              <PlayIcon />
              {i18n.t("listen_play_mob")}
            </Fragment>
          )
        }
        iconOnlyContent={playback ? <StopIcon /> : <PlayIcon />}
        isLoading={inProgress && !playback} // Only show loading when starting playback, not when stopping
      />
    );
  }),
);
